import { render } from "./OptionsOwner.vue?vue&type=template&id=47e69f02"
import script from "./OptionsOwner.vue?vue&type=script&lang=js"
export * from "./OptionsOwner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__